const countryCurrencyMap = {
  // --- Americas ---
  US: { code: "USD", symbol: "$" },
  CA: { code: "CAD", symbol: "CA$" },
  MX: { code: "MXN", symbol: "MX$" },

  // --- Europe / GBP & EUR ---
  GB: { code: "GBP", symbol: "£" },
  GI: { code: "GBP", symbol: "£" },
  DE: { code: "EUR", symbol: "€" },
  FR: { code: "EUR", symbol: "€" },
  IE: { code: "EUR", symbol: "€" },
  IT: { code: "EUR", symbol: "€" },
  ES: { code: "EUR", symbol: "€" },
  NL: { code: "EUR", symbol: "€" },
  AT: { code: "EUR", symbol: "€" },
  BE: { code: "EUR", symbol: "€" },
  PT: { code: "EUR", symbol: "€" },
  FI: { code: "EUR", symbol: "€" },
  GR: { code: "EUR", symbol: "€" },
  CY: { code: "EUR", symbol: "€" },
  EE: { code: "EUR", symbol: "€" },
  LV: { code: "EUR", symbol: "€" },
  LT: { code: "EUR", symbol: "€" },
  LU: { code: "EUR", symbol: "€" },
  MT: { code: "EUR", symbol: "€" },
  SK: { code: "EUR", symbol: "€" },
  SI: { code: "EUR", symbol: "€" },
  HR: { code: "EUR", symbol: "€" },

  // --- Europe / Others ---
  CH: { code: "CHF", symbol: "CHF" },
  LI: { code: "CHF", symbol: "CHF" },
  SE: { code: "SEK", symbol: "kr" },
  NO: { code: "NOK", symbol: "kr" },
  DK: { code: "DKK", symbol: "kr" },
  PL: { code: "PLN", symbol: "zł" },
  CZ: { code: "CZK", symbol: "Kč" },
  HU: { code: "HUF", symbol: "Ft" },
  RO: { code: "RON", symbol: "lei" },
  BG: { code: "BGN", symbol: "лв" },

  // --- Asia / Pacific ---
  AU: { code: "AUD", symbol: "A$" },
  NZ: { code: "NZD", symbol: "NZ$" },
  HK: { code: "HKD", symbol: "HK$" },
  JP: { code: "JPY", symbol: "¥" },
  SG: { code: "SGD", symbol: "S$" },
  TH: { code: "THB", symbol: "฿" },
  AE: { code: "AED", symbol: "د.إ" },
};

export const countryNameMap = {
  US: "United States",
  CA: "Canada",
  MX: "Mexico",
  GB: "United Kingdom",
  GI: "Gibraltar",
  DE: "Germany",
  FR: "France",
  IE: "Ireland",
  IT: "Italy",
  ES: "Spain",
  NL: "Netherlands",
  AT: "Austria",
  BE: "Belgium",
  PT: "Portugal",
  FI: "Finland",
  GR: "Greece",
  CY: "Cyprus",
  EE: "Estonia",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  MT: "Malta",
  SK: "Slovakia",
  SI: "Slovenia",
  HR: "Croatia",
  CH: "Switzerland",
  LI: "Liechtenstein",
  SE: "Sweden",
  NO: "Norway",
  DK: "Denmark",
  PL: "Poland",
  CZ: "Czech Republic",
  HU: "Hungary",
  RO: "Romania",
  BG: "Bulgaria",
  AU: "Australia",
  NZ: "New Zealand",
  HK: "Hong Kong SAR China",
  JP: "Japan",
  SG: "Singapore",
  TH: "Thailand",
  AE: "United Arab Emirates",
};

export const getCountryCodeFromName = (name) => {
  if (!name) return "";
  return Object.keys(countryNameMap).find(key => countryNameMap[key] === name) || name;
};

export const getCountriesList = () => {
  return Object.keys(countryNameMap).map(code => ({
    code,
    name: countryNameMap[code],
    currency: countryCurrencyMap[code].code
  })).sort((a, b) => a.name.localeCompare(b.name));
};

export const countryToCurrency = (countryCode) => {
  if (!countryCode) return { code: "EUR", symbol: "€" };
  return countryCurrencyMap[countryCode.toUpperCase()] || { code: "EUR", symbol: "€" };
};

export default countryCurrencyMap;
